import React, {useState} from "react";
import {StyleSheet} from "react-native";
import {connect, useDispatch, useSelector} from "react-redux";
import {Text, TextInput, View} from "react-native-web-ui-components";
import Button from "../components/Button";
import {selectUser} from "../redux/reducers";
import {useDimensions} from "react-native-responsive-ui/src";
import {useFormStyles} from "../components/forms/styles";
import axios from "axios";
import {SET_USER_DATA} from "../redux/actions";
import {showMessage} from "react-native-flash-message";

const GiftCardScreen = props => {
    const [activationCode, setActivationCode] = useState();
    const dispatch = useDispatch();
    const styles = useStyles();
    const GIFT_CARD_SCREEN_TEXT_SLUG = "kinkekaart";
    const staticContent = props.pages.find(page => page.identifier === GIFT_CARD_SCREEN_TEXT_SLUG);
    const details = useSelector(selectUser);
    const formStyles = useFormStyles();

    const activate = () => {
        if (activationCode) {
            axios.post(process.env.API2_URL + "/activate-gift-card", {
                activationCode: activationCode,
            }).then(({data}) => {
                setActivationCode(undefined);
                dispatch({
                    type: SET_USER_DATA,
                    payload: data,
                });
                showMessage({
                    message: 'Kinkekaart on aktiveeritud',
                    type: 'success',
                });

            }).catch(e => {
                if (e.response) {
                    console.log(e.response.status);
                    switch (e.response.status) {
                        case 404:
                            showMessage({
                                message: 'Kinkekaarti ei leitud',
                                type: 'danger',
                            });
                            break;
                        case 401:
                            showMessage({
                                message: 'Kinkekaart on juba aktiveeritud',
                                type: 'danger',
                            });
                            break;
                        default:
                            showMessage({
                                message: 'Kinkekaardi aktiveerimine ebaõnnestus',
                                type: 'danger',
                            });
                    }
                }
            });
        }
    }

    return (
        <View style={styles.container}>
            <Text style={styles.sectionTitle}>Aktiveeri kinkekaart</Text>

            <View style={styles.codeActivationContainer}>
                <View style={styles.codeActivationText}>
                    <Text style={styles.codeActivationLabel}>Soovid kinkekaarti lunastada?</Text>
                    <Text style={styles.codeActivationDescription}>{details
                        ? "Sisesta oma kinkekood siia, et see aktiveerida."
                        : " Kinkekaardi aktiveerimiseks pead olema sisse logitud."}
                    </Text>
                </View>
                <View style={styles.codeActivationForm}>
                    <View style={formStyles.inputContainer}>
                        <TextInput
                            autoFocus
                            style={formStyles.input}
                            focusStyle={[formStyles.input, formStyles.inputFocus]}
                            placeholder="Kinkekood"
                            onChangeText={activationCode => setActivationCode(activationCode)}
                            blurOnSubmit={false}
                            disabled={!details}
                        />
                    </View>
                    <Button
                        type="dark"
                        style={styles.codeActivationFormButton}
                        hoverStyle={styles.buttonHover}
                        textStyle={styles.buttonText}
                        textHoverStyle={styles.buttonTextHover}
                        onPress={activate}
                        disabled={!details}
                    >
                        Aktiveeri
                    </Button>
                </View>
            </View>

            {staticContent ? (
                <React.Fragment>
                    <View style={styles.container}>
                        <View style={styles.content}>
                            <div dangerouslySetInnerHTML={{__html: staticContent.content}}/>
                        </View>
                    </View>
                </React.Fragment>
            ) : null}
        </View>
    );
}

const mapStateToProps = ({pages}) => ({pages})

export default connect(mapStateToProps)(GiftCardScreen)

const useStyles = () => {
    const {width} = useDimensions()
    const isWide = width > 800
    return StyleSheet.create({
        container: {
            flex: 1,
            padding: 50,
        },
        sectionTitle: {
            marginTop: isWide ? 40 : 20,
            fontFamily: "Aino-Headline",
            fontSize: 24,
            display: "flex",
            justifyContent: "center"
        },
        codeActivationContainer: {
            margin: "auto",
            display: "flex",
            flexDirection: isWide ? "row" : "column",
            justifyContent: "space-evenly",
            alignContent: "center",
            backgroundColor: "rgba(241,241,241,0.15)",
            borderStyle: "solid",
            borderColor: "#6161FF",
            borderWidth: 1,
            borderRadius: 8,
            padding: 30,
            marginTop: 10,
            maxWidth: 1440,
            width: isWide ? "auto" : "100%"
        },
        codeActivationText: {
            marginTop: 20,
            marginRight: 20,
        },
        codeActivationFormButton: {
            width: "100%",
            marginTop: "2.5px"
        },
        codeActivationLabel: {
            fontSize: 18,
            fontWeight: "bold",
            marginBottom: 8,
            width: "auto"
        },
        codeActivationDescription: {
            fontSize: 14,
            marginBottom: 8,
            width: "auto"
        },
        codeActivationForm: {
            display: "flex",
            flexDirection: isWide ? "row" : "column",
            alignContent: "center",
            justifyContent: "center",
            marginTop: 20
        },
    })
};


